// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"3b85cace","649":"71b29447","839":"0be504e0"}[chunkId] + ".chunk.css";
};